import * as React from "react";
import {DocumentManager} from "../../Manager/PDFManager/DocumentManager";
import {Accordion} from "shared/controls/Accordion/Accordion";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faInfo} from "@fortawesome/free-solid-svg-icons/faInfo";
import './FieldSettings.css';
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {DropDownProperty} from "./Properties/DropDownProperty";
import {CheckBoxProperty} from "./Properties/CheckBoxProperty";
import {SimpleTextProperty} from "./Properties/SimpleTextProperty";
import {LicenseRequired} from "../../../PDFList/LicenseRequired";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {FormulaProperty} from "./Properties/FormulaProperty";
import {PDFButton} from "PDFLib/api";
import {ButtonProperty} from "./Properties/ButtonProperty";
import {AnnotationManager} from "PDFImporter/Manager/PDFManager/AnnotationManager";
import {ToastService} from "shared/core/services/ToastService";
import {PropertyBase} from "PDFImporter/Controls/FieldSettings/Properties/PropertyBase";

export class FieldSettings extends React.Component<FieldSettingsProps, FieldSettingsState> {
    static defaultProps: Partial<FieldSettingsProps> = {};

    constructor(props: FieldSettingsProps) {
        super(props);
        this.state = {};
    }



    public render() {
        if(this.props.DocumentManager.SelectedPDFField==null)
        {
            return(
                <div style={{backgroundColor:'white',padding:20}}>
                    <p>No field selected yet, please select one from your template</p>
                </div>
            )
        }

        let fieldSettings=this.props.DocumentManager.SelectedPDFField.GetFieldSettings();
        let styles=this.GetStyles();
        return (
            <Accordion>
                <AccordionItem ContentStyles={{padding:0,backgroundColor:'white'}} IsOpen={true} Title={'Field Information'} >
                    <div style={{width:'100%',padding:10}}>
                        {this.props.DocumentManager.SelectedPDFField==null?"Please select a pdf field before seeing it's settings here":
                           <table className={'fieldInformation'}>
                               <tbody>
                                   <tr>
                                       <th>Id:</th>
                                       <td>{this.props.DocumentManager.SelectedPDFField.Id}</td>
                                   </tr>
                                    <tr>
                                        <th>Name:</th>
                                        <td>{this.props.DocumentManager.SelectedPDFField.AnotationObject.fieldName}</td>
                                    </tr>
                                    <tr>
                                        <th>Type:</th>
                                        <td>{this.TypeToText(this.props.DocumentManager.SelectedPDFField.AnotationObject.fieldType)}</td>
                                    </tr>
                                    {this.AddAdditionalRows()}
                               </tbody>
                           </table>
                        }
                    </div>
                </AccordionItem>
                <AccordionItem Title={'Mapping'} IsOpen={true} ContentStyles={{padding:0,backgroundColor:'white'}}>
                    <div style={{padding:10}}>
                        {this.GetProperties().map((x,index)=>x.renderer(index.toString()))}
                    </div>
                </AccordionItem>
                {styles.length>0&&
                    <AccordionItem Title={'Style'} IsOpen={true} ContentStyles={{padding:0,backgroundColor:'white'}}>
                        <div style={{padding:10}}>
                            <p style={{margin:0,padding:0,marginBottom:10}}><span style={{color:"red"}}>Important:</span>Changes on the styles won't be reflected until the design is saved and this page reloaded</p>
                            {styles.map((value, index)=>value.renderer(index.toString()))}
                        </div>
                    </AccordionItem>
                }
            </Accordion>
        )

    }

    public GetStyles():PropertyBase[]{
        return [];
    }

    public GetProperties(){

        let fieldInformation=[];
        let mappedToDropDown=new DropDownProperty(this,'MappedTo').SetLabel('Mapped to');
        mappedToDropDown.AddOption(`None (don't map this field)`,'');
        mappedToDropDown.AddOption('Formula (full version only)','___formula');
        fieldInformation.push(mappedToDropDown);


        {this.props.DocumentManager.GetFields().map(field=> {
            if (this.props.DocumentManager.SelectedPDFField?.Field instanceof PDFButton && field.Type != 'FileUpload')
                return;
            mappedToDropDown.AddOption(field.Label, field.Id.toString())
        })};

        let fieldSettings=this.props.DocumentManager.SelectedPDFField.GetFieldSettings();
        fieldSettings.MappedTo=fieldSettings.MappedTo.toString();
        if(fieldSettings.MappedTo=='___formula')
        {
            if(rnImporterVar.IsPR=='')
            {
                Dialog.Show(<LicenseRequired Message={'Formulas are only available in the full version'} URL={rnImporterVar.PurchaseURL}/>)
                return;
            }

            fieldInformation.push(new FormulaProperty(this,'value'));



        }else {


            let field = this.props.DocumentManager.SelectedPDFField;

            let formField = this.props.DocumentManager.GetFields().find(x => x.Id == this.props.DocumentManager.SelectedPDFField.GetFieldSettings().MappedTo);
/*

            field.Field.acroField.getWidgets().forEach(x=>x.getOrCreateBorderStyle().setWidth(0));
            field.Field.defaultUpdateAppearances(field.Page.DocumentManager.Document.getForm().getDefaultFont());
 */

            if(field.AnotationObject.fieldType=='Ch')
            {
                fieldInformation.push(new CheckBoxProperty(this,'')
                    .SetLabel('Read Only')
                    .SetOnChangeExternalValue(newValue => {
                        if(newValue)
                            this.props.DocumentManager.SelectedPDFField.Field.enableReadOnly();
                        else
                            this.props.DocumentManager.SelectedPDFField.Field.disableReadOnly();
                        this.props.DocumentManager.RefreshDocument();
                        this.Refresh();
                    })
                    .SetExternalValue(this.props.DocumentManager.SelectedPDFField.Field.isReadOnly()));
            }

            if(field?.Field instanceof PDFButton)
            {
                fieldInformation.push(new ButtonProperty(this,'').SetText('Change Default Image').SetOnClick(()=>{this.ChangeButtonImage(field)}))
            }else
            if (field.AnotationObject.fieldType == 'Btn') {
                if (formField != null && formField.Type == 'Multiple') {
                    let dropdown = new DropDownProperty(this, 'CheckValues').SetMultiple(true).SetLabel('Check Value');
                    fieldInformation.push(dropdown);
                    for (let item of (formField as any).Items) {
                        dropdown.AddOption(item.Label, item.Label);
                    }

                } else {
                    if (fieldSettings.CheckValues.length > 1)
                        fieldSettings.CheckValues.splice(1);

                    if (fieldSettings.CheckValues.length == 0)
                        fieldSettings.CheckValues.push('');

                    fieldInformation.push(
                        new SimpleTextProperty(this, "CheckValue")
                            .SetLabel('Check Value')
                            .SetExternalValue(fieldSettings.CheckValues[0])
                            .SetOnChangeExternalValue(x => {
                                fieldSettings.CheckValues[0] = x;
                                this.forceUpdate()
                            })
                            .SetTooltip(<p>The box will be checked when the mapped field has this value</p>),
                        new CheckBoxProperty(this,'')
                            .SetLabel('Read Only')
                            .SetOnChangeExternalValue(newValue => {
                                if(newValue)
                                    this.props.DocumentManager.SelectedPDFField.Field.enableReadOnly();
                                else
                                    this.props.DocumentManager.SelectedPDFField.Field.disableReadOnly();
                                this.props.DocumentManager.RefreshDocument();
                                this.Refresh();
                            })
                            .SetExternalValue(this.props.DocumentManager.SelectedPDFField.Field.isReadOnly())
                    )
                }


            }


        }

        return fieldInformation;
    }
    public Refresh(){
        this.forceUpdate();
    }

    public TypeToText(type:string){
        switch (type)
        {
            case 'Ch':
                return 'Choice';
            case 'Btn':
                return 'Clickable';
            case 'Tx':
                return 'Text'
        }

        return type;
    }

    private AddAdditionalRows() {
        let field=this.props.DocumentManager.SelectedPDFField;
        if(field!=null&&field.AnotationObject.fieldType=='Btn'&&field.AnotationObject.exportValue!=null)
        {
            return (
                <tr>
                    <th>Export Value:</th>
                    <td>{field.AnotationObject.exportValue}</td>
                </tr>
            )
        }
    }

    private ChangeButtonImage(field: AnnotationManager) {
        let media = (window as any).wp.media({
            title: "Which image do you want to use in your pdf?",
            multiple: false,
            button: {
                text: 'Select an image'
            },
            library: {
                type: 'image'
            }
        });

        media.on('select',  ()=> {
            let selection = media.state().get('selection');
            if (selection == null)
                return;
            selection.each(async (attachment) =>{
                if(attachment.attributes.mime!='image/png'&&attachment.attributes.mime!='image/jpeg')
                {
                    ToastService.SendErrorMessage('Please use a jpeg or png image');
                    return;
                }

                try {
                    let image =await (await fetch(attachment.attributes.url)).arrayBuffer();
                    let embeddedImage=null;
                    if(attachment.attributes.mime=='image/png')
                        embeddedImage=await field.Page.DocumentManager.Document.embedPng(image);
                    if(attachment.attributes.mime=='image/jpeg')
                        embeddedImage=await field.Page.DocumentManager.Document.embedJpg(image);
                    if(embeddedImage==null)
                    {
                        ToastService.SendErrorMessage('Sorry the image could not be embedded into the pdf, please make sure the image is not corrupted');
                        return;
                    }

                    (field.Field as PDFButton).setImage(embeddedImage);
                    field.Page.DocumentManager.RefreshDocument();
                }catch (e) {
                    ToastService.SendErrorMessage('There was an error inserting the image, please try again '+e);
                    return;
                }





            });

        });

        media.open();


    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldSettingsProps {
    DocumentManager:DocumentManager;
}

interface FieldSettingsState {

}

//#endregion "My Region"